'use strict';

angular.module('ClinicApp').controller('ModalProviderOfferedAppointmentTypesCtrl', function($scope, $modalInstance, modelType, provider, ProviderService) {
  var DEFAULT_DURATION = 60;

  $scope.provider = provider;

  if (modelType == 'clinic') {
    $scope.modalTitle = 'Appointment Types Offered @ ' + provider.clinic.name;
  } else if (modelType == 'doctor') {
    $scope.modalTitle = 'Appointment Types Offered by ' + provider.doctor.name;
  } else {
    throw new Error('ModalArgumentError: `ModalProviderOfferedAppointmentTypesCtrl` invalid modelType value: ' + modelType);
  }

  // Model for the added offered service.
  $scope.offeredAppointmentType = {
    specialty: null,
    appointmentType: null,
    duration: DEFAULT_DURATION,
    price: null,
  };

  var potentialAppointmentTypesBySpecialty = _.groupBy($scope.provider.doctor.potentialAppointmentTypes, 'specialty');

  // Loading list of services for the selected specialty.
  $scope.$watch('offeredAppointmentType.specialty', function() {
    if ($scope.offeredAppointmentType.specialty) {
      $scope.offeredAppointmentType.specialty.appointmentTypes =
        potentialAppointmentTypesBySpecialty[$scope.offeredAppointmentType.specialty.id] || [];
      $scope.offeredAppointmentType.appointmentType = $scope.offeredAppointmentType.specialty.appointmentTypes[0];
    }
  });

  $scope.offeredAppointmentType.specialty = $scope.provider.doctor.specialties[0] || null;

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };

  $scope.addOfferedAppointmentType = function() {
    if (!$scope.offeredAppointmentType || !$scope.offeredAppointmentType.appointmentType) {
      return;
    }

    var appointmentTypeId = $scope.offeredAppointmentType.appointmentType.id;
    var duration = $scope.offeredAppointmentType.duration;
    var price = $scope.offeredAppointmentType.price;

    return ProviderService.addOfferedAppointmentType(
      $scope.provider.id,
      appointmentTypeId,
      duration,
      price,
    ).then(function(offeredAppointmentTypes) {
      $scope.provider.offeredAppointmentTypes = offeredAppointmentTypes;
      $scope.offeredAppointmentType.duration = DEFAULT_DURATION;
      $scope.offeredAppointmentType.price = null;
      $scope.offeredAppointmentTypeFormSubmitted = false;
    });
  };

  $scope.removeOfferedAppointmentType = function(offeredAppointmentType) {
    return ProviderService.removeOfferedAppointmentType(
      $scope.provider.id,
      offeredAppointmentType.id,
    ).then(function(offeredAppointmentTypes) {
      $scope.provider.offeredAppointmentTypes = offeredAppointmentTypes;
    });
  };
});
